import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Theme } from 'newCheckout/types/Theme'

type VisualProps = {
  isSingleGrid: boolean
}

const wrapperStyles = ({ theme }: Theme) => css`
  label: wrapper;

  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-areas:
    'delivery-button option-icon pickup-button'
    'delivery-link . pickup-link';

  padding: ${theme.spacings.giga} 0;
`

const isSingleGridStyles = ({ isSingleGrid }: VisualProps) =>
  isSingleGrid &&
  css`
    label: wrapper--single-grid;

    display: flex;
    flex-direction: column;
  `

const deliveryButtonStyles = () => css`
  label: delivery-button;

  grid-area: delivery-button;

  @media (min-width: 400px) {
    white-space: nowrap;
  }
`

const optionIconStyles = () => css`
  label: option-icon;

  grid-area: option-icon;
`

const pickupButtonStyles = () => css`
  label: pickup-button;

  grid-area: pickup-button;

  @media (min-width: 400px) {
    white-space: nowrap;
  }
`

const deliveryLinkStyles = () => css`
  label: delivery-link;

  grid-area: delivery-link;
`

const pickupLinkStyles = () => css`
  label: pickup-link;

  grid-area: pickup-link;
`

const optionLabelStyles = ({ theme }: Theme) => css`
  label: option-label;

  display: flex;
  justify-content: center;
  align-items: center;

  height: 46px;
  margin: 0px ${theme.spacings.byte};

  & > p {
    width: 28px;
    height: 28px;
    line-height: 0.7;

    padding: ${theme.spacings.byte};

    background-color: ${theme.colors.n100};
    border-radius: ${theme.borderRadius.circle};
  }
`

export const Wrapper = styled('div')(wrapperStyles, isSingleGridStyles)
export const DeliveryButton = styled('div')(deliveryButtonStyles)
export const OptionIcon = styled('div')(optionIconStyles)
export const PickupButton = styled('div')(pickupButtonStyles)
export const DeliveryLink = styled('div')(deliveryLinkStyles)
export const PickupLink = styled('div')(pickupLinkStyles)
export const OptionLabel = styled('div')(optionLabelStyles)
